import type { OnboardStudentBody } from "@shared-kernel/application/ports/shared/shared-repository";

// ============================================================================
// Default Values
// ============================================================================

export const defaultValues = {
  stageName: "",
};

// ============================================================================
// Formatter Function (converts form data to API body)
// ============================================================================

export const formatFormDataToOnboardStudentBody = (data: { stageName: string }): OnboardStudentBody => ({
  stageName: data.stageName ? data.stageName : null,
});
